import PaymentManagement from '../../Common/Payment/PaymentManagement';
import { useCreateCommonPayment } from '../../Common/apiEndpoints/commonApiEndpoints';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';

const B2BBuyerSellerPayment = () => {
  const {
    state: { b2bUser },
    dispatch: b2bAuthDispatch,
  } = B2BAuthContext();
  const { mutate, isSuccess } = useCreateCommonPayment();
  return (
    <PaymentManagement
      isSuccess={isSuccess}
      navigateUrl={'/b2b/invoice'}
      onChangeValue={async ({ payable_amount, ...data }) => {
        const formData = new FormData();
        const allValue = {
          ...data,
          user_id: b2bUser.b2b_id,
          user_type: 'B2B',
          payment_type: 'offline',
        };
        Object.keys(allValue).forEach((key) => {
          if (typeof allValue[key] === 'object') {
            formData.append(key, allValue[key][0]);
          } else {
            formData.append(key, allValue[key]);
          }
        });
        await mutate(formData);
      }}
    />
  );
};

export default B2BBuyerSellerPayment;
